// extracted by mini-css-extract-plugin
export default {"galleryHeading":"photo_galleryHeading__bneBn","image":"photo_image__dqPpo","galleryContainer":"photo_galleryContainer__BCCvP"};